import useConfig from 'AppShell/hooks/useConfig';
import { useMemo } from 'react';
import { Platforms, SvgComponentType } from 'OneWestwingFooter/hooks/useFooterPartnersInfo';
import loadable from '@loadable/component';

const Facebook = loadable(() => import('@westwing/ui-kit/Icons/FacebookIcon'));
const Instagram = loadable(() => import('@westwing/ui-kit/Icons/InstagramIcon'));
const Pinterest = loadable(() => import('@westwing/ui-kit/Icons/PinterestIcon'));
const TikTok = loadable(() => import('@westwing/ui-kit/Icons/TikTokIcon'));
const Youtube = loadable(() => import('@westwing/ui-kit/Icons/YoutubeIcon'));

export type SocialMediaData = {
    link: string;
    platform: Platforms;
    Logo: SvgComponentType;
    height?: number;
};

const pinterestHeight = 20;

export const useFooterSocialMedia = (): SocialMediaData[] => {
    const { currentCountry, links } = useConfig();
    const socialMediaData: { [p: string]: SocialMediaData[] } = useMemo<{ [key: string]: SocialMediaData[] }>(
        () => ({
            de: [
                { link: links.instagram, platform: Platforms.INSTAGRAM, Logo: Instagram },
                { link: links.youtube, platform: Platforms.YOUTUBE, Logo: Youtube },
                { link: links.pinterest, platform: Platforms.PINTEREST, Logo: Pinterest, height: pinterestHeight },
                { link: links.tiktok, platform: Platforms.TIKTOK, Logo: TikTok },
                { link: links.facebook, platform: Platforms.FACEBOOK, Logo: Facebook },
            ],
            ch: [
                { link: links.instagram, platform: Platforms.INSTAGRAM, Logo: Instagram },
                { link: links.youtube, platform: Platforms.YOUTUBE, Logo: Youtube },
                { link: links.pinterest, platform: Platforms.PINTEREST, Logo: Pinterest, height: pinterestHeight },
                { link: links.tiktok, platform: Platforms.TIKTOK, Logo: TikTok },
            ],
            nl: [
                { link: links.instagram, platform: Platforms.INSTAGRAM, Logo: Instagram },
                { link: links.pinterest, platform: Platforms.PINTEREST, Logo: Pinterest, height: pinterestHeight },
                { link: links.tiktok, platform: Platforms.TIKTOK, Logo: TikTok },
            ],
            pl: [
                { link: links.instagram, platform: Platforms.INSTAGRAM, Logo: Instagram },
                { link: links.pinterest, platform: Platforms.PINTEREST, Logo: Pinterest, height: pinterestHeight },
                { link: links.tiktok, platform: Platforms.TIKTOK, Logo: TikTok },
            ],
            fr: [
                { link: links.instagram, platform: Platforms.INSTAGRAM, Logo: Instagram },
                { link: links.pinterest, platform: Platforms.PINTEREST, Logo: Pinterest, height: pinterestHeight },
                { link: links.tiktok, platform: Platforms.TIKTOK, Logo: TikTok },
            ],
            es: [
                { link: links.instagram, platform: Platforms.INSTAGRAM, Logo: Instagram },
                { link: links.pinterest, platform: Platforms.PINTEREST, Logo: Pinterest, height: pinterestHeight },
                { link: links.tiktok, platform: Platforms.TIKTOK, Logo: TikTok },
            ],
            it: [
                { link: links.instagram, platform: Platforms.INSTAGRAM, Logo: Instagram },
                { link: links.pinterest, platform: Platforms.PINTEREST, Logo: Pinterest, height: pinterestHeight },
                { link: links.tiktok, platform: Platforms.TIKTOK, Logo: TikTok },
            ],
            sk: [],
            cz: [
                { link: links.instagram, platform: Platforms.INSTAGRAM, Logo: Instagram },
                { link: links.tiktok, platform: Platforms.TIKTOK, Logo: TikTok },
            ],
        }),
        [links.facebook, links.instagram, links.pinterest, links.tiktok, links.youtube]
    );
    return socialMediaData[currentCountry ?? 'de'];
};
